import { type FC, memo } from 'react';
import styles from './index.module.scss';
import { Dialog, type DialogProps } from 'evergreen-ui';

interface OwnProps extends DialogProps {}

const ParrotDialog: FC<OwnProps> = ({ children, ...props }) => {
  return (
    <Dialog
      width={500}
      hasFooter={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEscapePress={false}
      overlayProps={{
        className: styles.parrot_overlay,
      }}
      containerProps={{
        className: styles.parrot_dialog,
      }}
      contentContainerProps={{
        className: styles.parrot_content,
      }}
      {...props}
    >
      {props.isShown ? children : undefined}
    </Dialog>
  );
};

export default memo(ParrotDialog);
